import { z } from 'zod';
// --- Operator registry (Single Source of Truth) ---
export const TARGETING_OPERATORS = ['eq', 'neq', 'in', 'nin', 'gt', 'lt', 'gte', 'lte'];
// --- Targeting rule ---
export const targetingRuleSchema = z
    .object({
    attribute: z
        .string()
        .min(1)
        .max(100)
        .meta({ description: 'Visitor attribute name to match against', example: 'country' }),
    operator: z
        .enum(TARGETING_OPERATORS)
        .meta({ description: 'Comparison operator (eq, neq, in, nin, gt, lt, gte, lte)' }),
    value: z
        .union([z.string().max(1000), z.number(), z.array(z.string().max(1000)).max(100)])
        .meta({
        description: 'Value to compare against — string, number, or string array for in/nin operators',
    }),
})
    .meta({
    id: 'TargetingRule',
    description: 'A single targeting condition evaluated against visitor attributes',
});
// --- Targeting config ---
export const TARGETING_MATCH_MODES = ['all', 'any'];
export const targetingSchema = z
    .object({
    rules: z
        .array(targetingRuleSchema)
        .min(1)
        .max(50)
        .meta({ description: 'Array of targeting rules (1-50)' }),
    match: z
        .enum(TARGETING_MATCH_MODES)
        .meta({ description: 'How rules combine: all (AND) or any (OR)' }),
})
    .meta({ id: 'Targeting', description: 'Targeting configuration with rules and match mode' });
//# sourceMappingURL=targeting.js.map